<script>
	import Navbar from "./components/Navbar.svelte";
	import Footer from "./components/Footer.svelte";
	import { useForm, validators, required } from "svelte-use-form";
	import { api_dumpData } from "./stores.js";
	import { arrayObjects2CSV, sortByKey } from "./utils.js";

	let idName;
	let message = "Enter experiment ID or stimulus set name";
	let dataType; // engagement or user_form

	const form = useForm();
	let fields = [
		{
			labelName: "dataType",
			label: "What do you want to download?",
			options: [
				{
					type: "radio",
					value: "engagement",
					option: "Feed engagement data", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "user_form",
					option: "User information",
					validate: [required],
				},
				{
					type: "radio",
					value: "entity_info",
					option: "Entity information (covariates for stimuli/entities)",
					validate: [required],
				},
				{
					type: "radio",
					value: "experiment_parameters",
					option: "Experiment parameters",
					validate: [required],
				},
				{
					type: "radio",
					value: "inventory",
					option: "Inventory (for creating custom feed algorithms)",
					validate: [required],
				},
				{
					type: "radio",
					value: "stimulus_set",
					option: "Stimulus set (enter set name instead of experiment ID)",
					validate: [required],
				},
			],
		},
		{
			labelName: "idName",
			label: "",
			options: [
				{
					type: "input",
					value: "",
					option: "",
					validate: [required],
				},
			],
		},
	];

	async function dumpData(idName, dataType) {
		message = "⏳ Downloading data...";
		console.log("Downloading data - calling dump_data...");

		let payload = {
			idName: idName,
			data_type: dataType,
		};
		if (dataType == "stimulus_set") {
			payload["stimulus_set"] = idName;
		} else {
			payload["experiment_id"] = idName;
		}
		console.log(payload);

		const resp = await fetch($api_dumpData, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify(payload),
		});

		let dat;
		const data = await resp.json();
		if (data.success) {
			dat = JSON.parse(data.data);
			dat = decode(dat);
			console.log("decoded data", dat);
			if (Object.values(dat).length > 0) {
				decode(dat);
				message = "✔️ Finish downloading data";
				toCSV(dat);
			} else {
				message =
					"✖️ No data found. Did you enter your experiment ID correctly?";
			}
		} else {
			console.log("Failed to download data");
			message = "🙈 Whoops. Something went wrong. 🙉";
		}
	}

	const onSubmit = () => {
		idName = $form["idName"]._value;
		dataType = $form["dataType"]._value;
		console.log(idName, dataType);
		dumpData(idName, dataType);
	};

	const decode = (obj) => {
		obj.forEach((o, idx) => {
			try {
				// decode response value
				if (o.hasOwnProperty("response")) {
					obj[idx]["response"] = decodeURIComponent(
						obj[idx]["response"]
					);
				}
			} catch (error) {
				console.log(obj[idx]["response"], error);
			}
		});
		return obj;
	};

	const toCSV = (data) => {
		message = "⏳ Processing downloaded data";
		data = sortByKey(data, "condition");
		data = sortByKey(data, "parameter");
		console.log("Convert data to csv:", data);
		let csv = arrayObjects2CSV(data);
		message = "⌛ Data ready for download. Preparing csv...";

		// document.write(csv);
		let hiddenElement = document.createElement("a");
		hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
		hiddenElement.target = "_blank";
		let filename = idName + "_" + dataType + ".csv";
		hiddenElement.download = filename;
		hiddenElement.click();
	};
</script>

<Navbar />
<section>
	<h1>📥 Download data</h1>

	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				{#if field.labelName === "idName"}
					<p>{message}</p>
				{/if}
				<label for={field.labelName}>{field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={option.validate}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button disabled={!$form.valid} on:click|preventDefault={onSubmit}
			>Download</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}
	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: block;
	}
</style>
